
import {
  BASE_URL_4,
  instance4,
} from "App/constants";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import fileDownload from "js-file-download";
import { getUserName } from "App/utils/cookies";
import { MasterButton } from "App/Component/ui";
export const urlCreateMTwithHD = "/wmsAsset/maintance/add-helpdesk";
export const urlCreateMT = "/wmsAsset/maintance/add-header";
export const urlUpdateMT = "/wmsAsset/maintance/update-header";
export const urlGetReqById = "/wmsAsset/request/list_id";

export const urlVerifikasiBarang = "/wmsAsset/helpdesk/update-status-detail";
export const urlUpdateStatus = "/wmsAsset/maintance/update-status";

export const urlGetMaintenanceById = "/wmsAsset/maintance/list-id";

export const STATUS_OPEN_DRAFT = false;
export const STATUS_PROCESS = true;


// Status Validasi Perbarang
export const STATUS_BARANG_PENGAJUAN = 0;
export const STATUS_BARANG_PROSES = 1;
export const STATUS_BARANG_SELESAI = 2;
export const STATUS_BARANG_RUSAK = 3;
export const STATUS_BARANG_DISPOSE = 4;

export const STYLE_MASTER_FA = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
});

export const FORM_RESET_STATE_WMS_MT = {
  id: "",
  id_helpdesk_header:"",

  unit_id: null,
  unit: "Pilih Unit",

  gudang_id: null,
  gudang: "Pilih Gudang",

  remark: "",

  vendor_id:"",
  vendor:"Pilih Vendor",

  pic:"",
  user_request: getUserName(),
  status_service: 0,

  type: "create",
  status: true,

  isOpenDraf: false,
  isProcess: false,
  tanggal_service: moment(new Date()).local().toDate(),
};

export const FORM_RESET_DETAIL = {
    id: "",
    id_service_header: "",
    fixasset_id: "",
    is_garansi: false,
    tanggal_akhir_garansi: moment(new Date()).local().toDate(),
    is_maintenance: false,
    tanggal_maintenance_selanjutnya: moment(new Date()).local().toDate(),
    nama_asset: "",
    code_asset: "",
    no_faktur: "",
    deskripsi_kerusakan: "",
    kelengkapan : "",
    status_barang:"",
    remark:"",
    detail_perbaikan : [],
}

export const FORM_RESET_LIST_DETAIL = {
  index: null,
  status: "",
  pembelian: "",
  harga: "",
}

export const FORM_RESET_VERIFIKASI = {
  id: null,
  fixasset_id: "",
  nama_asset: "",
  code_asset: "",
  remark: "",
}

export const downloadPDF = async (id, fileName) => {
  try {
    const api = await instance4.get(`${BASE_URL_4}/wmsAsset/maintance/download_file/${id}`, {
      responseType: "blob",
    });
      fileDownload(api.data, fileName);
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getReqById = async (id) => {
  try {
    const api = await instance4.get(`${urlGetReqById}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data:
          res.data.length > 0
            ? res.data[0]
            : {
                totalTax: 0,
                jumlah: 0,
              },
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getMaintenanceData = async (id) => {
  try {
    const api = await instance4.get(`${urlGetMaintenanceById}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        detail : res.data.detail,
        data_file:res.data.data_file,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    align: "left",
  },
  {
    id: "name_asset",
    disablePadding: false,
    label: "NAMA ASSET",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "code_asset",
    disablePadding: false,
    label: "CODE ASSET",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "kelengkapan",
    disablePadding: false,
    label: "KELENGKAPAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "STATUS",
    align: "left",
  },
  {
    id: "no_faktur",
    disablePadding: false,
    label: "NO. FAKTUR",
    align: "center",
    minWidth: "180px",
  },
  {
    id: "deskripsi_kerusakan",
    disablePadding: false,
    label: "DESKRIPSI KERUSAKAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "is_garansi",
    disablePadding: false,
    label: "GARANSI",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "tanggal_akhir_garansi",
    disablePadding: false,
    label: "TGL AKHIR GARANSI",
    align: "left",
    minWidth: "180px",
  },
];

export const setPerhitungan = (formData, setFormData, row) => {
  return setFormData({
    ...formData,
    jumlah: row?.jumlah,
    tax: row?.tax,
    total_jumlah: row?.total_jumlah,
  });
};

export const status_barang = [
  {
    label: "PEMERIKSAAN",
    value: STATUS_BARANG_PENGAJUAN,
  },
  {
    label: "PROSES PERBAIKAN",
    value: STATUS_BARANG_PROSES,
  },
  {
    label: "SELESAI",
    value: STATUS_BARANG_SELESAI,
  },
  {
    label: "RUSAK",
    value: STATUS_BARANG_RUSAK,
  },
]

export const deleteById = async (id) => {
  try {
    const api = await instance4.post("/wmsAsset/maintance/delete-detail", { id }, {});
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus Data",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const RenderStatusMTBarang = ({ status }) => {
  // eslint-disable-line
  if (status === STATUS_BARANG_PENGAJUAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PEMERIKSAAN"}
        color={"secondary"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_BARANG_PROSES) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PROSES PERBAIKAN"}
        color={"lightgreen"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_BARANG_SELESAI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"SELESAI"}
        color={"green"}
        type="button"
        disabled
      />
    );
  }else if (status === STATUS_BARANG_RUSAK) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"RUSAK"}
        color={"warning"}
        type="button"
        disabled
      />
    );
  }else if (status === STATUS_BARANG_DISPOSE) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"DISPOSE"}
        color={"danger"}
        type="button"
        disabled
      />
    );
  } else {
    return <p>-</p>;
  }
};


